import React, { useState, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';
import {
	useGetOnboardingState,
	useOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

import { RovoModal } from './RovoModal';

export const RovoVideoModal = () => {
	const { isRovoEnabled: isRovoEnabledInTCS } = useSessionData();
	const { setOnboardingState } = useOnboardingState();
	const { data: onboardingStateData, loading: loadingOnboardingState } = useGetOnboardingState(
		Object.values({ ...ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS }),
	);
	const { rovoVideoPlayerSeen } = deserializeState(onboardingStateData);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const [showModal, setShowModal] = useState<boolean>(false);

	useEffect(() => {
		if (isRovoEnabledInTCS && !rovoVideoPlayerSeen && !loadingOnboardingState) {
			setShowModal(true);
		}
	}, [isRovoEnabledInTCS, loadingOnboardingState, rovoVideoPlayerSeen]);

	const handleOnClose = () => {
		void setOnboardingState({
			key: ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS.ROVO_VIDEO_PLAYER_SEEN,
			value: 'true',
		});
		setShowModal(false);
	};

	if (showModal) {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: 'rovoVideoModal',
			},
		}).fire();

		return <RovoModal onClose={handleOnClose} />;
	}

	return null;
};
